var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowentiChatMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2B4C7E",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78 92              H 322              a 30 30 0 0 1 30 30              V 232              a 30 30 0 0 1 -30 30              H 188              l -44 46              v -46              H 78              a 30 30 0 0 1 -30 -30              V 122              a 30 30 0 0 1 30 -30 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 177,
    r: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 177,
    x2: 178,
    y2: 177
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200 153 L 224 177 L 200 201 L 176 177 Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 169,
    x2: 208,
    y2: 185
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 185,
    x2: 208,
    y2: 169
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224,
    y1: 177,
    x2: 262,
    y2: 177
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 177,
    r: 19,
    strokeWidth: 14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowentiChatMark);
export default __webpack_public_path__ + "static/media/flowenti-chat-mark.6a0af550d84564ffb798d9855760ee0e.svg";
export { ForwardRef as ReactComponent };